
// What's New Block Carousel
jQuery("#block-views-block-whats-new-block-latest-posts .view-content").slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	infinite: false,
	variableWidth: false,
	focusOnSelect: true,
	responsive: [
		{
      breakpoint: 1024,
      settings: {
				slidesToShow: 2,
      }
    },
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 1,
			}
		}
	]
});
